<template>
  <div>
    <div class='fd-nav'>
      <div class='fd-nav-left'>
        <div class='fd-nav-back' @click='toReturn'><i class='anticon anticon-left'></i></div>
        <div class='fd-nav-title'>
          <a type='info' @click='handleShowSetting'>{{ workFlowDef.name }}</a>
        </div>
      </div>
      <!-- <div class="fd-nav-center">
                <div class="fd-nav-container">
                    <div class="ghost-bar" style="transform: translateX(300px);"></div>
                    <div class="fd-nav-item"><span class="order-num">1</span>基础设置</div>
                    <div class="fd-nav-item"><span class="order-num">2</span>表单设计</div>
                    <div class="fd-nav-item active"><span class="order-num">3</span>流程设计</div>
                    <div class="fd-nav-item"><span class="order-num">4</span>高级设置</div>
                </div>
            </div> -->
      <div class='fd-nav-right'>
        <!-- <button type="button" class="ant-btn button-preview"><span>预 览</span></button> -->
        <button type='button' class='ant-btn button-publish' @click='saveSet'><span>发 布</span></button>
      </div>
    </div>
    <div class='fd-nav-content'>
      <section class='dingflow-design'>
        <div class='zoom'>
          <div :class="'zoom-out'+ (nowVal==50?' disabled':'')" @click='zoomSize(1)'></div>
          <span>{{ nowVal }}%</span>
          <div :class="'zoom-in'+ (nowVal==300?' disabled':'')" @click='zoomSize(2)'></div>
        </div>
        <div class='box-scale' id='box-scale'
             :style="'transform: scale('+nowVal/100+'); transform-origin: 50% 0px 0px;'">
          <nodeWrap :nodeConfig.sync='nodeConfig' :flowPermission.sync='flowPermission'></nodeWrap>
          <div class='end-node'>
            <div class='end-node-circle'></div>
            <div class='end-node-text'>流程结束</div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog title='配置内容' :visible.sync='visibleDialog' width='75%'>
      <div class='editor'>
        <el-input type='textarea' :value='JSON.stringify(this.processConfig, null, 4)' rows='40' readonly>

        </el-input>
        <div class='p-10'>
          <el-button type='primary' icon='el-icon-document-copy' @click='handleCopy'>复制配置</el-button>
          <el-button type='primary' @click='handleSave'>保存</el-button>
        </div>

      </div>

    </el-dialog>
    <errorDialog
      :visible.sync='tipVisible'
      :list='tipList'
    />
    <promoterDrawer />
    <approverDrawer :directorMaxLevel='directorMaxLevel' />
    <copyerDrawer />
    <conditionDrawer />
  </div>
</template>
<script>
import errorDialog from '@/components/workflow/dialog/errorDialog'
import promoterDrawer from '@/components/workflow/drawer/promoterDrawer'
import approverDrawer from '@/components/workflow/drawer/approverDrawer'
import copyerDrawer from '@/components/workflow/drawer/copyerDrawer'
import conditionDrawer from '@/components/workflow/drawer/conditionDrawer'
// import { getWorkFlowData, setWorkFlowData } from '@/plugins/api.js'
import { getWorkFlowData, setWorkFlowData } from '@/api/com/workflow.js'
import { mapMutations } from 'vuex'

export default {
  components: {
    errorDialog,
    promoterDrawer,
    approverDrawer,
    copyerDrawer,
    conditionDrawer
  },
  data() {
    return {
      tipList: [],
      tipVisible: false,
      visibleDialog: false,
      nowVal: 100,
      processConfig: {},
      nodeConfig: {},
      workFlowDef: {},
      flowPermission: [],
      directorMaxLevel: 0
    }
  },
  created() {
    getWorkFlowData({ tpl_id: this.$route.params.workFlowDefId }).then(({ data }) => {
      this.processConfig = data
      const { nodeConfig, flowPermission, directorMaxLevel, workFlowDef, tableId } = data
      this.nodeConfig = nodeConfig
      this.flowPermission = flowPermission
      this.directorMaxLevel = directorMaxLevel
      this.workFlowDef = workFlowDef
      this.setTableId(tableId)
    })
  },
  methods: {
    ...mapMutations(['setTableId', 'setIsTried']),
    toReturn() {
      //window.location.href = ""
      this.$router.go(-1)
    },
    reErr({ childNode }) {
      if (childNode) {
        const { type, error, nodeName, conditionNodes } = childNode
        if (type == 1 || type == 2) {
          if (error) {
            this.tipList.push({ name: nodeName, type: ['', '审核人', '抄送人'][type] })
          }
          this.reErr(childNode)
        } else if (type == 3) {
          this.reErr(childNode)
        } else if (type == 4) {
          this.reErr(childNode)
          for (let i = 0; i < conditionNodes.length; i++) {
            if (conditionNodes[i].error) {
              this.tipList.push({ name: conditionNodes[i].nodeName, type: '条件' })
            }
            this.reErr(conditionNodes[i])
          }
        }
      } else {
        childNode = null
      }
    },
    async saveSet() {
      this.setIsTried(true)
      this.tipList = []
      this.reErr(this.nodeConfig)
      if (this.tipList.length != 0) {
        this.tipVisible = true
        return
      }
      this.processConfig.flowPermission = this.flowPermission
      // eslint-disable-next-line no-console
      const { id } = await setWorkFlowData(this.processConfig)
      if (id) {
        await this.$alert('设置成功', '发布结果', {
          confirmButtonText: '确定',
          confirmButtonClass: 'confirm-btn',
          callback: () => {
            window.location.reload()
            // this.$router.push({ 'name': 'oaSetting' })
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        })
        // this.$message.success('设置成功')
        // setTimeout(() => {
        //   // window.location.href = ""
        //   this.$router.push({ 'name': 'oaSetting' })
        // }, 1000)
      }
    },
    zoomSize(type) {
      if (type == 1) {
        if (this.nowVal == 50) return
        this.nowVal -= 10
      } else {
        if (this.nowVal == 300) return
        this.nowVal += 10
      }
    },
    handleCopy() {

      const val = JSON.stringify(this.processConfig)
      //复制到剪切板
      navigator.clipboard.writeText(val)
        .then(() => {
          this.msgSuccess('复制成功：审批流程配置')
        }).catch(err => console.error('复制失败:', err))

    },
    handleShowSetting() {
      this.visibleDialog = true
      this.$nextTick(() => {
        const editor = document.querySelector('.editor')
        editor.addEventListener('paste', (e) => {
          try {
            e.preventDefault() // 可选，阻止默认粘贴行为
            // 处理粘贴事件，例如获取剪贴板内容
            const clipboardData = e.clipboardData || window.clipboardData
            const pastedData = clipboardData.getData('Text') // 获取文本数据

            const config = JSON.parse(pastedData)
            // console.log('Pasted data:', config)
            this.processConfig.nodeConfig = config.nodeConfig
          } catch (err) {
            console.error('Failed to read clipboard contents: ', err)
            this.msgWarn('粘贴失败：审批流程配置')
          }

        })
      })

    },
    handleSave() {
      // this.processConfig.nodeConfig =
      this.saveSet()
      this.visibleDialog = false

    }
  }
}
</script>

<style>
@import "./css/app.css";
@import "./css/override-element-ui.css";
@import "./css/workflow.css";

.error-modal-list {
  width: 455px;
}

.confirm-btn {
  background-color: var(--primary) !important;
  color: white !important;
}
</style>
